const STORAGE_PREFIX = 'video-play-count:';
const ONE_HOUR = 60 * 60 * 1000;

function getHourlyIncrement(videoId, hour) {
  let hash = Number(videoId) || 1;
  hash = Math.imul(hash ^ hour, 2654435761) >>> 0;
  return 10 + (hash % 191);
}

export function getDisplayPlayCount(videoId, serverCount) {
  const numericServerCount = Number(serverCount) || 0;
  if (process.env.NODE_ENV !== 'development' || typeof localStorage === 'undefined') {
    return numericServerCount;
  }

  const storageKey = `${STORAGE_PREFIX}${videoId}`;
  const currentHour = Math.floor(Date.now() / ONE_HOUR);
  let state;

  try {
    state = JSON.parse(localStorage.getItem(storageKey));
  } catch (error) {
    state = null;
  }

  if (!state || !Number.isFinite(state.count) || !Number.isFinite(state.hour)) {
    state = {
      count: Math.floor(Math.random() * 99999) + 1,
      hour: currentHour,
    };
  }

  while (state.hour < currentHour) {
    state.hour++;
    state.count += getHourlyIncrement(videoId, state.hour);
  }

  localStorage.setItem(storageKey, JSON.stringify(state));
  return state.count;
}

